/**
 * @generated SignedSource<<944043de1c6a0a4dbb659b92c292f16e>>
 * @relayHash ed985aea87bf4b5c1198acbdc5b4fee0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ff11a2edecea665730730303b713d56939899135db19a95e52438616de472ec8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_DesignModalQuery } from './ui_DesignModalQuery.graphql';

const node: PreloadableConcreteRequest<ui_DesignModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ff11a2edecea665730730303b713d56939899135db19a95e52438616de472ec8",
    "metadata": {},
    "name": "ui_DesignModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
